import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from 'styled-components';
import { Icon } from '../icon';
var ToggleContainerConfig = {
  small: {
    width: '32px',
    height: '16px',
    lineHeight: '16px'
  },
  medium: {
    width: '40px',
    height: '24px',
    lineHeight: '24px'
  },
  large: {
    width: '60px',
    height: '36px',
    lineHeight: '36px'
  }
};
var sliderConfig = {
  small: {
    size: {
      width: '12px',
      height: '12px'
    },
    sliderPosition: '17px'
  },
  medium: {
    size: {
      width: '16px',
      height: '16px'
    },
    sliderPosition: '21px'
  },
  large: {
    size: {
      width: '24px',
      height: '24px'
    },
    sliderPosition: '32px'
  }
};
var xDifPos = {
  small: '- 3px',
  medium: '- 2px',
  large: '- 1px'
};
var yDifPos = {
  small: '- 4.5px',
  medium: '- 1.2px',
  large: '+ 2px'
};
export var ToggleContainer = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: ", ";\n  height: ", ";\n  line-height: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return ToggleContainerConfig[size].width;
}, function (_ref2) {
  var size = _ref2.size;
  return ToggleContainerConfig[size].height;
}, function (_ref3) {
  var size = _ref3.size;
  return ToggleContainerConfig[size].lineHeight;
});
export var MakeToggleSlider = function MakeToggleSlider(_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled,
      _ref4$checked = _ref4.checked,
      checked = _ref4$checked === void 0 ? false : _ref4$checked,
      size = _ref4.size;

  var setBgColor = function setBgColor() {
    if (disabled) {
      return theme.colors.grey24;
    }

    if (!checked) {
      return theme.toggle.unChecked.bg;
    }

    return theme.toggle.checked.bg;
  };

  var setBorder = function setBorder() {
    if (disabled && !checked) {
      return theme.colors.grey36;
    }

    if (!checked) {
      return theme.colors.grey24;
    }

    return 'transparent';
  };

  var sliderColor = checked ? theme.toggle.checked.slide : theme.toggle.unChecked.slide;
  return "\n    position: absolute;\n    cursor: ".concat(disabled ? 'default' : 'pointer', ";\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ").concat(setBgColor(), ";\n    border-radius: 100px;\n   border: 1px solid ").concat(setBorder(), ";\n\n    &:before{\n      position: absolute;\n      content:'';\n      left: 3px;\n      ").concat(checked ? "left: ".concat(sliderConfig[size].sliderPosition, ";") : "4px;", " \n      top: 50%;\n      transform: translate( 0, -50% );\n      width: ").concat(sliderConfig[size].size.width, ";\n      height: ").concat(sliderConfig[size].size.height, ";\n      background-color: ").concat(disabled ? theme.toggle.disabled.slide : sliderColor, ";\n      transition: left 0.2s;\n      border-radius: 50%;\n    }\n  ");
};
export var ToggleInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none !important;\n"])));
var horizontalPos = {
  small: '161%',
  medium: '194%',
  large: '230%'
};
export var CustomIcon = styled(Icon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  transform: translate(\n    ", "\n  );\n"])), function (_ref5) {
  var position = _ref5.position,
      checked = _ref5.checked;
  return "calc(".concat(checked ? horizontalPos[position] : '50%', " ").concat(xDifPos[position], "),calc(50% ").concat(yDifPos[position], ")");
});
export var ToggleSlider = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return MakeToggleSlider(props);
});